module.exports = "/_next/static/resources/water-5618d90d7d555d612e39cd6fd214ec58.webp";